module.exports = __webpack_public_path__ + "static/media/menu_home_default.ca84de93.svg";